<div class="reset-password-process">
  <h6>{{ 'module.public.resetPasswordProcess.headerText' | translate }}</h6>

  <form [formGroup]="resetPasswordProcessForm" class="form">
    <div class="form-group" formGroupName="passwords">
      <div class="input-container">
        <div class="form-field bordered-form-field">
          <input
            formControlName="newPassword"
            matInput
            type="password"
            class="input borderless-input"
            placeholder="{{ 'module.public.resetPasswordProcess.newPasswordPlaceholderText' | translate }}"
            maxLength="20"
            autocomplete="off"
          />
        </div>
        <div class="form-field">
          <input
            formControlName="confirmPassword"
            matInput
            type="password"
            [errorStateMatcher]="matcher"
            maxLength="20"
            autocomplete="off"
            class="input"
            placeholder="{{ 'module.public.resetPasswordProcess.newConfirmPasswordPlaceholderText' | translate }}"
            onPaste="return false"
          />
        </div>
        <div class="error-message" *ngIf="newPassword?.value !== confirmPassword?.value">
          {{ 'module.public.resetPasswordProcess.errorMessageText' | translate }}
        </div>
      </div>
      <app-password-requirements [control]="newPassword"></app-password-requirements>
      <button class="buttons" [class.-disabled]="resetPasswordProcessForm.invalid" [disabled]="resetPasswordProcessForm.invalid" (click)="save()">
        {{ 'module.public.resetPasswordProcess.submitButtonText' | translate }}
      </button>
    </div>
  </form>
</div>
